module.exports = __webpack_public_path__ + "img/idcard_front.5b74349d.png";